import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { UFOExperience } from '@atlassian/ufo';
import { isAuthError, isErrorStatusCode, isNetworkError, StatusCode } from '../error';
import { createErrorMetadata, isIgnoredError } from './utils';
export var TeamsUFOExperience = /*#__PURE__*/function (_UFOExperience) {
  _inherits(TeamsUFOExperience, _UFOExperience);
  var _super = _createSuper(TeamsUFOExperience);
  function TeamsUFOExperience() {
    _classCallCheck(this, TeamsUFOExperience);
    return _super.apply(this, arguments);
  }
  _createClass(TeamsUFOExperience, [{
    key: "abortWithError",
    value: function abortWithError(error, reason) {
      return _get(_getPrototypeOf(TeamsUFOExperience.prototype), "abort", this).call(this, {
        metadata: {
          error: createErrorMetadata(error),
          reason: reason
        }
      });
    }
  }, {
    key: "failWithError",
    value: function failWithError(error) {
      if (error instanceof Error) {
        if (isAuthError(error)) {
          return this.abortWithError(error, 'Abort due to user unauthenticated');
        }
        if (isErrorStatusCode(StatusCode.GONE, error)) {
          return this.abortWithError(error, 'Abort due to unavailable resource');
        }
        if (isIgnoredError(error)) {
          return this.abortWithError(error, 'Abort due to an error in ignore list');
        }
        if (isNetworkError(error)) {
          return this.abortWithError(error, 'Abort due to network error');
        }
        return _get(_getPrototypeOf(TeamsUFOExperience.prototype), "failure", this).call(this, {
          metadata: {
            error: createErrorMetadata(error),
            packageVersion: "2.47.1",
            packageName: "@atlassian/teams-client"
          }
        });
      }
      return _get(_getPrototypeOf(TeamsUFOExperience.prototype), "failure", this).call(this, {
        metadata: {
          error: 'unknown error',
          packageVersion: "2.47.1",
          packageName: "@atlassian/teams-client"
        }
      });
    }
  }]);
  return TeamsUFOExperience;
}(UFOExperience);